module.exports = __webpack_public_path__ + "img/specialist.c14dba9e.png";